import React from 'react';
import PropTypes from 'prop-types';

const FiletypeImagePath = ({ fill = '#D94174' }) => {
  return (
    <path
      fill={fill}
      d="M25.316 9.681c.382.365.684 1.082.684 1.609v15.084c0 .898-.763 1.626-1.701 1.626H7.701C6.762 28 6 27.272 6 26.374V5.626C6 4.728 6.763 4 7.701 4h10.717c.539 0 1.261.293 1.639.654l5.259 5.027zM9.59 22.107c-.24.493.018.893.567.893h11.61c.553 0 .857-.432.685-.945 0 0-3.032-9.083-3.146-9.331-.35-.643-.927-.515-1.205.103l-2.202 5.394c-.052.126-.17.16-.278.065l-2.087-1.836c-.46-.404-1.048-.287-1.31.25L9.59 22.107zm3.246-4.229c.08-.171.27-.214.422-.086l2.437 2.066c.213.18.47.115.583-.14 0 0 1.324-2.991 1.67-3.858.346-.866.304-.77.456-1.158.152-.389.135-.322.135-.322.09-.186.222-.179.3-.002 0 0 .048.057.296.818.25.76 1.947 6.437 1.947 6.437.058.194-.06.343-.262.343h-9.524c-.204 0-.299-.142-.217-.317l1.757-3.781zM10 11.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0zm4 0a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z"
    />
  );
};

FiletypeImagePath.propTypes = {
  fill: PropTypes.string,
};

export default FiletypeImagePath;



// WEBPACK FOOTER //
// ./src/icon/svgs/filetype/filetype-image.jsx